/**
 * Which build is this? A built index.html loads one hashed entry script
 * (`/assets/index-<hash>.js`); a new deploy names a new one. Comparing the
 * entry this tab loaded with the one the server's index.html names now is
 * how an open tab learns a new version is live (the reload banner,
 * hooks/useNewBuild). Pure.
 */

const ENTRY = /\/assets\/index-[\w-]+\.js/;

/** The built entry a page names, or null (the dev server's `/src/main.jsx`, an error page, nothing). */
export function entryOf(html: string): string | null {
  return html.match(ENTRY)?.[0] ?? null;
}

/** A newer build is live only when both entries are known and differ: not knowing is never news. */
export function isNewBuild(loaded: string | null, served: string | null): boolean {
  return !!loaded && !!served && loaded !== served;
}
